class CreateAccountController {
    static create({env}) {
        var eulaPackages = env.getInstitution().getEulaPackages(),
            eulaRequired = eulaPackages.length > 0;

        return new CreateAccountController({env, eulaPackages, eulaRequired});
    }

    constructor({env, eulaPackages, eulaRequired}) {
        this.env = env;
        this.eulaRequired = eulaRequired;

        this.mainDialog = env.getDialog('create-account-dialog').setEulaCheckFieldVisible(eulaRequired);
        this.eulaDialog = env.getDialog('eula-dialog').setPackages(eulaPackages);
        this.accountExistsDialog = env.getDialog('username-unavailable-dialog');

        this.initEvents();
    }

    initEvents() {
        this.env.onNav('createAccount', ({email}) => this.show({email}));

        this.mainDialog.on('hideGesture', () => this.onMainDialogCancelGesture());
        this.mainDialog.on('submitGesture', () => this.onSubmitGesture());
        this.mainDialog.on('eulaLink:click', () => this.onEulaLinkClick());
        this.mainDialog.on('signInLink:click', () => this.navToSignIn());

        this.accountExistsDialog.on('resetPasswordButton:click', () => this.navToResetPassword());
        this.accountExistsDialog.on('signInButton:click', () => this.navToSignIn());
    }

    clearErrors() {
        this.mainDialog.clearErrors();
    }

    getEmail() {
        return this.mainDialog.getEmail();
    }

    navToResetPassword() {
        this.env.navTo('resetPassword', {email: this.getEmail()});
    }

    navToSignIn() {
        this.env.navTo('userSignIn', {email: this.getEmail()});
    }

    onEulaLinkClick() {
        this.eulaDialog.show().then(() => this.mainDialog.show());
    }

    onMainDialogCancelGesture() {
        this.navToSignIn();
    }

    onSubmitGesture() {
        this.clearErrors();

        var {email, password1, password2, eulaChecked} = this.mainDialog.getState();

        if (!this.env.isValidEmail(email)) {
            this.mainDialog.addInvalidEmailError();
            return;
        }
        else if (!this.env.isValidUserPassword(password1)) {
            this.mainDialog.addInvalidPasswordError();
            return;
        }
        else if (password1 !== password2) {
            this.mainDialog.addDifferentPasswordsError();
            return;
        }
        else if (!eulaChecked && this.eulaRequired) {
            this.mainDialog.addEulaError();
            return;
        }

        this.mainDialog.setSubmitting(true);

        this.env.getProxy().createAccount({email, password: password1})
            .then(() => {
                this.mainDialog.setSubmitting(false);

                this.env.showDialog('account-created-dialog').then(() => this.navToSignIn());
            })
            .catch(error => {
                this.mainDialog.setSubmitting(false);

                if (error.hasType('UsernameAlreadyExists')) {
                    this.accountExistsDialog.show();
                    return;
                }

                throw error;
            });
    }

    show({email}) {
        this.mainDialog.reset();
        this.mainDialog.setEmail(email);
        this.mainDialog.show();
        this.mainDialog.focusEmailField();
    }

    uncheckEulaCheckbox() {
        this.mainDialog.uncheckEulaCheckbox();
    }
}

export default CreateAccountController;